import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import useMediaQuery from '@mui/material/useMediaQuery'; // Import useMediaQuery
import { useTheme } from '@mui/material/styles'; // Import useTheme
// api
import { deleteOffice } from 'src/api/office';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { convertDateToEST, convertTimeToEST, formatDateToLocal, formatDateToLocal2 } from 'src/utils/format-time';
//

// ----------------------------------------------------------------------

export default function GoBackTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, role }) {
  const { _id, zoneId,followupDate, address, prefferedTime,zone } = row;
  const [loading, setLoading] = useState(false);
  const confirm = useBoolean();
  const edit = useBoolean();
  const { enqueueSnackbar } = useSnackbar();
  const quickEdit = useBoolean();

  const theme = useTheme(); // Initialize useTheme
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if screen is mobile (e.g., less than 'sm' breakpoint)


  const popover = usePopover();
  const handleDelete = async () => {
    setLoading(true);
    try {
      const data = await deleteOffice(_id);
      if (data.code === 200) {
        confirm.onFalse();
        enqueueSnackbar(data.message);
      } else {
        console.log(data);
        enqueueSnackbar(data.message, { variant: 'error' });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };
  const formatLeadStatus = (status) => {
    if (!status) return '';
    return status
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  return (
    <>
      <TableRow hover selected={selected}>

        <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '30%' }}>{zone?.zoneName}</TableCell>
        <TableCell
          sx={{
            maxWidth: isMobile ? 'unset' : '30%', // unset maxWidth for mobile
            overflow: 'hidden',
            textOverflow: isMobile ? 'unset' : 'ellipsis', // unset textOverflow for mobile
            wordBreak: isMobile ? 'break-word' : 'unset', // allow word break on mobile
            whiteSpace: isMobile ? 'normal' : 'nowrap', // normal whiteSpace for mobile
            width: isMobile ? '30%' : 'unset', // full width for mobile
          }}
        >
          {isMobile ? (
            <span style={{ display: 'block', width: '100%' }}>{address.replace(/,/g, '') || 'N/A'}</span>
          ) : (
            <Tooltip title={address.replace(/,/g, '') || 'N/A'} arrow>
              <span>
                {address ? (address.length > 30 ? `${address.slice(0, 30)}...` : address).replace(/,/g, '') : 'N/A'}
              </span>
            </Tooltip>
          )}
        </TableCell>
        <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '30%' }}>{convertDateToEST(followupDate)} at {' '}
          {convertTimeToEST(prefferedTime)}
          {/*{formatDateToLocal}*/}
        </TableCell>
        <TableCell align="left" sx={{ px: 3, whiteSpace: 'nowrap' }}>
          <IconButton size="small" color="primary" sx={{ color: '#2065D1' }}>
            <Iconify icon="mdi:bell-outline" height={22} width={22} />
          </IconButton>
        </TableCell>
      </TableRow>





    </>
  );
}

GoBackTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
